import routes from '../routes/constants'
import type { Permissions } from 'appPermissions'

interface Props {
  text: string
  path: string
  permissions: Permissions[]
}

export const HeaderMenuLinks: Props[] = [
  {
    text: 'Inbox',
    path: routes.INBOX_PATH,
    permissions: ['inbox.view'],
  },
  {
    text: 'Rolling credit',
    path: routes.ROLLING_CREDIT,
    permissions: ['rolling-credit'],
  },
  {
    text: 'Accounting',
    path: routes.ACCOUNTING_PATH,
    permissions: ['accounting'],
  },
  {
    text: 'Spend controls',
    path: routes.SPEND_CONTROLS,
    permissions: ['spend-controls'],
  },
]
